import ConsumableIns from "./ConsumableTable";
import FormSection from "./PrescriptionDetails";

const Forms = ({ step }) => {
  if (step === -1) {
    return <FormSection />;
  }

  if (step === 0) {
    return <ConsumableIns />;
  }

  return null;
};

export default Forms;
